import Utilization from "./Utilization";

export default Utilization;